import { Carrousel } from "./carrousel";
import { ConfigurationDto } from "./configuration-dto";

export class Configuration {
    baseUrl: string;
    CNPJ: string;
    themeColor: string;
    background: string;
    shortcutBarColor: string;
    shortcutBarColorEnd: string;
    categoriesButtonColor: string;
    color: string;
    src: string;
    chechout: string;
    displayOffer: string;
    offer: boolean;
    carrousel: Carrousel [];
    featuredCategory: number [];
    salescode: number
    operator: number;
    codOper: number;
    branch: number;
    priceTable: number;
    storageId: number;
    accountId: number;
    storageTypeReconciled: string;
    paymentFormId: number;
    receivingConditionId: number;
    infoProductDetail: boolean;
    displayCarousel: boolean;

    static fromJson(json: ConfigurationDto): Configuration {
        var configuration = new Configuration();
        configuration.baseUrl = json.base_url;
        configuration.CNPJ = json.CNPJ;
        configuration.themeColor = json.theme_color;
        configuration.background = json.background;
        configuration.shortcutBarColor = json.shortcut_bar_color;
        configuration.shortcutBarColorEnd = json.shortcut_bar_color_end;
        configuration.color = json.color;
        configuration.src = json.src;
        configuration.chechout = json.chechout;
        configuration.carrousel = json.carrousel.map((element) => Carrousel.fromJson(element));
        configuration.featuredCategory = json.featured_category;
        configuration.salescode = json.salescode;
        configuration.operator = json.operator;
        configuration.codOper = json.codOper;
        configuration.branch = json.branch;
        configuration.priceTable = json.priceTable;
        configuration.storageId = json.storageId;
        configuration.accountId = json.accountId;
        configuration.storageTypeReconciled = json.storageTypeReconciled;
        configuration.paymentFormId = json.paymentFormId;
        configuration.receivingConditionId = json.receivingConditionId;
        configuration.offer = json.offer;
        configuration.displayOffer = json.displayOffer;
        configuration.infoProductDetail = json.infoProductDetail ?? true;
        configuration.displayCarousel = json.displayCarousel ?? true;
        configuration.categoriesButtonColor = json.categories_button_color ?? '#00569A';
        return configuration;
    }
}
